import * as diacritics from "diacritics";
import _ from "../../../shared/utils/lodash";
export function replaceApostrophes(str) {
    return str.replace(/[ʻʼ’‘`´]/g, "'");
}
var removeDiacritics = diacritics.remove;
var cleanQuery = _.flow([
    replaceApostrophes,
    removeDiacritics,
    encodeURIComponent,
]);
export default cleanQuery;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/utils/cleanQuery.ts
// module id = ij64
// module chunks = 2